<template>
  <base-wrapper>
    <CashbillNueraTable view-as="pusat" />
  </base-wrapper>
</template>

<script>
import CashbillNueraTable from '../../../../components/cashbill-nuera/cashbill-nuera-table.vue';

export default {
  components: {
    CashbillNueraTable,
  }
};
</script>
